import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-summary',
  templateUrl: './document-summary.component.html',
  styleUrls: ['./document-summary.component.css']
})
export class DocumentSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
